// src/hooks/useAuth.js (COM LOGS DE DEPURAÇÃO)

import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import { auth, db } from '../firebaseconfig';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('[useAuth] Hook montado. Iniciando verificação...');
    
    const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
      console.log('[useAuth] onAuthStateChanged disparado. currentUser:', currentUser?.email || null);
      
      if (!currentUser) {
        setUser(null);
        setUserData(null);
        setLoading(false);
        console.log('[useAuth] Usuário deslogado. Loading: false.');
      } else {
        setUser(currentUser);
        const userDocRef = doc(db, 'usuarios', currentUser.uid);
        
        const unsubscribeFirestore = onSnapshot(userDocRef, (docSnap) => {
          console.log('[useAuth] onSnapshot do Firestore disparado.');
          if (docSnap.exists()) {
            console.log('[useAuth] Documento do usuário encontrado:', docSnap.data());
            setUserData(docSnap.data());
          } else {
            console.log('[useAuth] Documento do usuário NÃO encontrado no Firestore.');
            setUserData(null);
          }
          setLoading(false);
          console.log('[useAuth] Dados do Firestore carregados. Loading: false.');
        }, (error) => {
            console.error("[useAuth] Erro no onSnapshot:", error);
            setLoading(false);
        });
        
        return () => unsubscribeFirestore();
      }
    });

    return () => unsubscribeAuth();
  }, []);

  return { user, userData, loading };
};